module.exports = __webpack_public_path__ + "media/images/defaulttemplate-bf2e472b.png";